function compareDate(a: Date, b: Date) {
    if (a && !b) return 1;
    else if (!a && b) return -1;
    else if (!a && !b) return 0;

    return a > b ? 1 : b > a ? -1 : 0;
}

export default compareDate;
